import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { Typography } from '@mui/material'
import { fetchAdminWeddingTypes } from '../../../../features/adminSlice'
import styles from '../AdminConfigsPage.module.scss'

export function WeddingTypesListPage() {
	const dispatch = useDispatch()
	const weddingTypes = useSelector((s) => s.admin.weddingTypes)
	const loading = useSelector((s) => s.admin.weddingTypesLoading)
	const error = useSelector((s) => s.admin.weddingTypesError)

	useEffect(() => {
		dispatch(fetchAdminWeddingTypes())
	}, [dispatch])

	return (
		<div className={styles.panelCard} data-cy="admin-wedding-types-list">
			<div className={styles.panelHeaderRow}>
				<Typography component="h2" className={styles.panelTitle}>
					Wedding types
				</Typography>
				<Link
					to="/admin/configs/wedding-tasks/defaults"
					className={styles.panelLink}
					data-cy="admin-default-tasks-link"
				>
					All default tasks
				</Link>
			</div>
			<p className={styles.panelBody}>
				Each wedding type maps to a task list in the database. Select a
				row to view tasks and notification configuration for that list.
			</p>
			{loading && <p className={styles.panelBody}>Loading…</p>}
			{error && <p className={styles.errorText}>{error}</p>}
			{!loading && !error && weddingTypes == null && (
				<p className={styles.panelBody}>Loading…</p>
			)}
			{!loading && !error && weddingTypes?.length === 0 && (
				<p className={styles.panelBody}>
					No task catalog data found. Run{' '}
					<code>cd server && npm run pop</code> after starting the
					server.
				</p>
			)}
			{weddingTypes?.length > 0 && (
				<table className={styles.configTable}>
					<thead>
						<tr>
							<th>Wedding type</th>
							<th>Task list</th>
							<th>Tasks</th>
						</tr>
					</thead>
					<tbody>
						{weddingTypes.map((row) => (
							<tr
								key={row.weddingType}
								data-cy={`admin-wedding-type-row-${row.taskListKey}`}
							>
								<td>
									<Link
										to={`/admin/configs/wedding-tasks/list/${row.taskListKey}`}
										className={styles.tableLink}
									>
										{row.weddingType}
									</Link>
								</td>
								<td>
									<code>{row.taskListKey}</code>
								</td>
								<td>{row.taskCount}</td>
							</tr>
						))}
					</tbody>
				</table>
			)}
		</div>
	)
}
